import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import { getStaticImage } from "../../product/utils/static";
import { TopBarLogo } from "../../product/accounts/company/topbar";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import { useBreakpoint } from "../../product/utils/hooks";
import { faBars, faXmarkLarge } from "@fortawesome/pro-solid-svg-icons";
import IconButtonNew from "../../product/global/buttonsLinks/IconButtonNew";
import TopbarNav from "./TopbarNav";
import { openButton } from "../../product/utils/z-index";

export const ResponsiveC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;

  @media (min-width: 1280px) {
    width: 1400px;
    display: inherit;
    margin: 0 auto;
    align-items: inherit;
  }
`;

const TopbarContainer = styled.div`
  height: 70px;
  position: fixed;
  background-color: ${(props) => props.theme.colors.white};
  top: 0;
  left: 0;
  right: 0;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.colors.grays4};
  z-index: ${openButton};
`;

const MenuIcon = styled(IconButtonNew)`
  margin-left: 30px;
  margin-right: 20px;
`;

const Topbar = (): JSX.Element => {
  const history = useHistory();
  const theme = useTheme();
  const { isDesktop } = useBreakpoint();
  const [isMenuOpen, setIsMenuOpen] = useState(isDesktop);
  return (
    <>
      <TopbarContainer>
        <ResponsiveC>
          <TopBarLogo
            src={getStaticImage("heavenhr-logo.png")}
            alt="heavenLogo"
            onClick={() => history.push("/")}
          />
          {isDesktop && <TopbarNav active={true} />}
          <Button
            style={{ marginLeft: "auto" }}
            variant={"contained"}
            color={"secondary"}
            onClick={() => history.push("/app/login")}
          >
            Login
          </Button>
          {!isDesktop && (
            <MenuIcon
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              size="lg"
              backgroundColor={theme.colors.grays7}
              iconColor={theme.colors.primary1}
              icon={isMenuOpen ? faXmarkLarge : faBars}
            />
          )}
        </ResponsiveC>
      </TopbarContainer>
      {!isDesktop && <TopbarNav active={isMenuOpen} />}
    </>
  );
};

export default Topbar;
